<template>
  <el-card class="cardFlex card-main">
     <div class="left">
       <div class="leftItem" :class="deviceType === index ? 'current' : ''" v-for="(item, index) in typeList" :key="index" @click="changeType(index)" v-show="item.showType">{{item.name}}</div>
     </div>
     <div class="right">
       <!-- 查询 -->
       <el-form ref="searchInfo" :model="searchInfo" class="global-form" :inline="true">
         <el-form-item>
           <el-input v-model="searchInfo.deviceName" placeholder="请输入设备名称" clearable></el-input>
         </el-form-item>
         <el-form-item>
           <el-input v-model="searchInfo.deviceNumber" placeholder="请输入设备串号" clearable></el-input>
         </el-form-item>
         <el-form-item>
           <el-select v-model="searchInfo.projectId" placeholder="请选择分配项目" clearable filterable>
             <el-option
               v-for="item in projectList"
               :key="item.projectId"
               :label="item.projectName"
               :value="item.projectId"
             ></el-option>
           </el-select>
         </el-form-item>
         <el-form-item>
           <el-select v-model="searchInfo.deviceStatus" clearable placeholder="请选择设备状态">
             <el-option label="在线" value="1"></el-option>
             <el-option label="离线" value="2"></el-option>
           </el-select>
         </el-form-item>
         <el-form-item>
           <el-select v-model="searchInfo.allotStatus" clearable placeholder="请选择分配状态">
             <el-option label="已分配" value="1"></el-option>
             <el-option label="未分配" value="2"></el-option>
           </el-select>
         </el-form-item>
         <el-form-item>
           <el-button type="primary" class="medium" @click="searchData">查询</el-button>
         </el-form-item>
       </el-form>
       <el-button type="primary" class="mb20" @click="batchAllocate" v-show="$ButtonShow('DEV_EDT_02')">批量分配</el-button>
       <el-button type="primary" class="mb20" @click="batchDeploy" v-show="$ButtonShow('DEV_DEP_01') && deviceType === 0">批量配置</el-button>
       <el-table ref="tables" class="global-table" v-loading="loading" :data="tableData" row-key="deviceId">
         <el-table-column type="selection" width="55" fixed="left"></el-table-column>

         <!-- 左侧固定 -->
         <el-table-column label="设备名称" show-overflow-tooltip prop="deviceName" min-width="100"></el-table-column>
         <el-table-column label="设备串号" show-overflow-tooltip prop="deviceNumber" min-width="100"></el-table-column>
         <el-table-column v-if="deviceType !== 6" label="设备状态" min-width="100">
           <template v-slot="{ row }">{{row.deviceStatus === '1' ? '在线' : row.deviceStatus === '2' ? '离线' : ''}}</template>
         </el-table-column>

         <!-- 表格动态列 -->
         <el-table-column
           :label="item.label"
           :prop="item.prop"
           show-overflow-tooltip
           v-for="(item,index) in getTableTRList()"
           :key="index"
           :min-width="item.minWidth">
             <!-- 土壤 -->
             <template v-slot="{ row }" v-if="item.label === '监测状态'">{{row.runStatus === '0' ? '正常' : row.runStatus === '1' ? '异常' : ''}}</template>
             <!-- 虫情 -->
             <template v-slot="{ row }" v-else-if="item.label === '工作状态'">{{row.ws === '0' ? '待机' : row.ws === '1' ? '工作' : ''}}</template>
             <template v-slot="{ row }" v-else-if="item.label === '灯管状态'">{{row.lamp === '0' ? '灭' : row.lamp === '1' ? '亮' : ''}}</template>
             <template v-slot="{ row }" v-else-if="item.label === '雨控状态'">{{row.rps === '0' ? '正常' : row.rps === '1' ? '雨控' : ''}}</template>
             <template v-slot="{ row }" v-else-if="item.label === '光控状态'">{{row.lps === '0' ? '正常' : row.lps === '1' ? '光控' : ''}}</template>
             <template v-slot="{ row }" v-else-if="item.label === '温控状态'">{{row.lps === '0' ? '正常' : row.lps === '1' ? '温控' : ''}}</template>
             <!-- 割草机器人 -->
             <template v-slot="{ row }" v-else-if="item.label === '溢满状态'">{{row.trashcan1Status === '0' ? '正常' : row.trashcan1Status === '1' ? '满溢' : ''}}</template>
             <!-- 割草机器人 -->
             <template v-slot="{ row }" v-else-if="item.label === '运行状态' && item.type === 8">{{runStateList[row.runState]}}</template>

             <template v-slot="{ row }" v-else-if="item.label === '水压状态'">{{pressureStatusList[row.pressureStatus]}}</template>
             <template v-slot="{ row }" v-else-if="item.label === '风向'">{{directionTransition(row.direction)}}</template>
             <template v-slot="{ row }" v-else-if="item.label === '运行状态' && item.type === 13">{{row.switchStatus === '1' ? '开启' : row.switchStatus === '0' ? '关闭' : '--' }}</template>
         </el-table-column>

         <!-- 右侧固定 -->
         <el-table-column v-if="deviceType !== 6" label="上报时间" width="200px" show-overflow-tooltip prop="collectTime"></el-table-column>
         <el-table-column label="分配状态" fixed="right" min-width="100">
           <template v-slot="{ row }">{{row.allotStatus === '1' ? '已分配' : row.allotStatus === '2' ? '未分配' : ''}}</template>
         </el-table-column>
         <el-table-column label="分配项目" show-overflow-tooltip prop="projectName" fixed="right" min-width="100"></el-table-column>
         <el-table-column label="操作" width="200px" fixed="right">
           <template v-slot="{ row }">
             <el-button type="text" @click="toDetail(row)">查看</el-button>
             <el-button type="text" @click="allocate(row)" v-show="$ButtonShow('DEV_EDT_02')">分配</el-button>
             <el-button type="text" @click="deploy(row)" v-show="$ButtonShow('DEV_DEP_01') && (deviceType === 0 || deviceType === 12)">配置</el-button>
             <el-button type="text" @click="toHistory(row.deviceNumber)" v-show="$ButtonShow('DEV_SEL_02') && deviceType !== 6">历史数据</el-button>
           </template>
         </el-table-column>
       </el-table>
       <global-pagination
         @size-change="getData"
         @current-change="getData"
         :current-page.sync="page"
         :page-size.sync="size"
         :total="total"
       ></global-pagination>

       <!-- 批量分配 -->
       <el-dialog title="分配" :visible.sync="showAllocateDialog" width="500px" :close-on-click-modal='false'>
         <el-form ref="allocateForm" class="global-formElse" :model="allocateInfo" label-width="120px">
           <el-form-item label="选择项目" prop="projectId">
             <el-select v-model="allocateInfo.projectId" filterable clearable placeholder="请选择分配项目">
               <el-option v-for="(item, index) in projectList" :label="item.projectName" :value="item.projectId" :key="index"></el-option>
             </el-select>
           </el-form-item>
         </el-form>
         <div slot="footer" class="dialog-footer">
           <el-button type="primary" :loading="allocateLoading" @click="allocateDevice">保存</el-button>
           <el-button @click="showAllocateDialog = false">取消</el-button>
         </div>
       </el-dialog>

       <!-- 土壤配置 -->
       <Setting :soilDialog.sync="soilDialog" :finds='finds' :deviceNumber='allocateInfo.deviceNumber' @closeDialog="closeDialog" @getData="getData"></Setting>
       <!-- 流速配置 -->
       <waterDialog :waterDialog.sync="waterDialog" :detail='allocateInfo' @closeDialog="closeDialog" @success="getData"></waterDialog>
     </div>
   </el-card>
 </template>

<script>
import keepAlive from '@/mixins/keepAlive.js'
import Setting from './Setting.vue'
import waterDialog from './waterDialog.vue'
import { directionTransition } from '@/utils/formatData'
export default {
  name: 'Device',
  mixins: [keepAlive],
  components: {
    Setting,
    waterDialog
  },
  data () {
    return {
      searchInfo: {
        isCad: '0',
        deviceName: '',
        deviceNumber: '',
        projectId: '',
        deviceStatus: '',
        allotStatus: ''
      },
      typeList: [
        {
          name: '土壤监测',
          name1: '土壤监测',
          showType: false
        },
        {
          name: '智慧虫情',
          name1: '虫情预测',
          showType: false
        },
        {
          name: '水质监测',
          name1: '水质监测',
          showType: false
        },
        {
          name: '环境监测',
          name1: '局部天气',
          showType: false
        },
        {
          name: '智慧水表',
          name1: '水电管理',
          showType: false
        },
        {
          name: '智慧电表',
          name1: '水电管理',
          showType: false
        },
        {
          name: '智慧监控',
          name1: '视频监控',
          showType: false
        },
        {
          name: '智慧垃圾桶',
          name1: '卫生保洁',
          showType: false
        },
        {
          name: '割草机器人',
          name1: '智能割草',
          showType: false
        },
        {
          name: '电磁阀',
          name1: '智慧喷灌',
          showType: false
        },
        {
          name: '智慧工牌',
          name1: '工人管理',
          showType: false
        },
        {
          name: '智慧手环',
          name1: '工人管理',
          showType: false
        },
        {
          name: '流压监测',
          name1: '智慧喷灌',
          showType: false
        },
        {
          name: '智慧雾森',
          name1: '智慧雾森',
          showType: false
        }
      ],
      projectList: [],
      deviceType: null,
      page: 1,
      size: 10,
      total: 0,
      tableData: [],
      loading: false,
      showAllocateDialog: false,
      allocateLoading: false,
      allocateInfo: {
        deviceNumber: [],
        projectId: ''
      },
      // 土壤配置弹窗
      finds: [],
      soilDialog: false,
      waterDialog: false,
      // allocateRules: {
      //   projectId: [
      //     { required: true, message: '请选择项目', trigger: 'change' }
      //   ]
      // },
      tableTR: [
        // 土壤
        {
          label: '监测状态',
          prop: 'runStatus',
          type: 0,
          normal: true,
          minWidth: 80
        },
        {
          label: '温度（℃）',
          prop: 'temperature',
          type: 0,
          normal: false,
          minWidth: 100
        },
        {
          label: '湿度（%）',
          prop: 'humidity',
          type: 0,
          normal: false,
          minWidth: 100
        },
        {
          label: 'pH',
          prop: 'ph',
          type: 0,
          normal: false,
          minWidth: 80
        },
        {
          label: 'EC（mS/cm）',
          prop: 'conductivity',
          type: 0,
          normal: false,
          minWidth: 120
        },
        {
          label: 'ORP（mv）',
          prop: 'redox',
          type: 0,
          normal: false,
          minWidth: 100
        },
        {
          label: '氮（mg/kg）',
          prop: 'nitrogen',
          type: 0,
          normal: false,
          minWidth: 100
        },
        {
          label: '磷（mg/kg）',
          prop: 'phosphorus',
          type: 0,
          normal: false,
          minWidth: 100
        },
        {
          label: '钾（mg/kg）',
          prop: 'potassium',
          type: 0,
          normal: false,
          minWidth: 100
        },
        {
          label: '所属物种',
          prop: 'maintTypeName',
          type: 0,
          normal: true,
          minWidth: 80
        },
        {
          label: '地面深度（cm）',
          prop: 'depth',
          type: 0,
          normal: true,
          minWidth: 120
        },
        // 虫情
        {
          label: '工作状态',
          prop: 'ws',
          type: 1,
          normal: true,
          minWidth: 100
        },
        {
          label: '灯管状态',
          prop: 'lamp',
          type: 1,
          normal: true,
          minWidth: 100
        },
        {
          label: '加热仓温度（℃）',
          prop: 'hrt',
          type: 1,
          normal: true,
          minWidth: 120
        },
        {
          label: '环境温度（℃）',
          prop: 'at',
          type: 1,
          normal: true,
          minWidth: 120
        },
        {
          label: '光照强度（Lux）',
          prop: 'lux',
          type: 1,
          normal: true,
          minWidth: 120
        },
        {
          label: '环境湿度（%）',
          prop: 'ah',
          type: 1,
          normal: true,
          minWidth: 120
        },
        {
          label: '雨控状态',
          prop: 'rps',
          type: 1,
          normal: true,
          minWidth: 100
        },
        {
          label: '光控状态',
          prop: 'lps',
          type: 1,
          normal: true,
          minWidth: 100
        },
        {
          label: '温控状态',
          prop: 'tps',
          type: 1,
          normal: true,
          minWidth: 100
        },
        // 水质
        {
          label: '水位（cm）',
          prop: 'waterLevel',
          type: 2,
          normal: false,
          minWidth: 100
        },
        {
          label: 'pH',
          prop: 'ph',
          type: 2,
          normal: false,
          minWidth: 80
        },
        {
          label: '水温（℃）',
          prop: 'temperature',
          type: 2,
          normal: false,
          minWidth: 100
        },
        {
          label: '电导率（μs/cm）',
          prop: 'conductivity',
          type: 2,
          normal: false,
          minWidth: 120
        },
        {
          label: '浊度（NTU）',
          prop: 'turbidity',
          type: 2,
          normal: false,
          minWidth: 100
        },
        {
          label: '溶解氧（mg/L）',
          prop: 'dissolvedOxygen',
          type: 2,
          normal: false,
          minWidth: 120
        },
        {
          label: '氨氮（mg/L）',
          prop: 'ammoniaNitrogen',
          type: 2,
          normal: false,
          minWidth: 100
        },
        // 环境
        {
          label: '温度（℃）',
          prop: 'temperature',
          type: 3,
          normal: false,
          minWidth: 100
        },
        {
          label: '湿度（%）',
          prop: 'humidity',
          type: 3,
          normal: false,
          minWidth: 100
        },
        {
          label: '降雨量（mm)',
          prop: 'precipitation',
          type: 3,
          normal: false,
          minWidth: 110
        },
        {
          label: '气压(pa)',
          prop: 'pressure',
          type: 3,
          normal: false,
          minWidth: 100
        },
        {
          label: '风向',
          prop: 'direction',
          type: 3,
          normal: false,
          minWidth: 100
        },
        {
          label: '风速(m/s)',
          prop: 'speed',
          type: 3,
          normal: false,
          minWidth: 100
        },
        {
          label: '负氧离子(个/cm³）',
          prop: 'negativeOxyge',
          type: 3,
          normal: false,
          minWidth: 130
        },
        {
          label: '噪音（db)',
          prop: 'noise',
          type: 3,
          normal: false,
          minWidth: 100
        },
        {
          label: 'PM2.5（μg/m³）',
          prop: 'pm25',
          type: 3,
          normal: false,
          minWidth: 120
        },
        {
          label: 'PM10（μg/m³）',
          prop: 'pm10',
          type: 3,
          normal: false,
          minWidth: 120
        },
        {
          label: '二氧化碳（ppm）',
          prop: 'co2',
          type: 3,
          normal: false,
          minWidth: 120
        },
        {
          label: '总辐射（mwh/cm²）',
          prop: 'zfs',
          type: 3,
          normal: false,
          minWidth: 140
        },
        {
          label: '光照度（Lux)',
          prop: 'lux',
          type: 3,
          normal: false,
          minWidth: 120
        },
        // 水表
        {
          label: '水表度数(m³)',
          prop: 'wmLacc',
          type: 4,
          normal: false,
          minWidth: 120
        },
        {
          label: '当日用水(m³)',
          prop: 'wmDayLacc',
          type: 4,
          normal: false,
          minWidth: 120
        },
        // 电表
        {
          label: '电表度数（kW·h）',
          prop: 'electric',
          type: 5,
          normal: false,
          minWidth: 120
        },
        {
          label: '分合闸状状态',
          prop: 'state',
          type: 5,
          normal: true,
          minWidth: 120
        },
        {
          label: '电压（V）',
          prop: 'voltage',
          type: 5,
          normal: false,
          minWidth: 120
        },
        {
          label: '电流（A）',
          prop: 'current',
          type: 5,
          normal: false,
          minWidth: 120
        },
        {
          label: '溢满状态',
          prop: 'trashcan1Status',
          type: 7,
          normal: false,
          minWidth: 120
        },
        {
          label: '预设割草面积(m²)',
          prop: 'mowingArea',
          type: 8,
          normal: true,
          minWidth: 120
        },
        {
          label: '预设割草时间',
          prop: 'mowingTime',
          type: 8,
          normal: true,
          minWidth: 120
        },
        {
          label: '运行状态',
          prop: 'runState',
          type: 8,
          normal: true,
          minWidth: 120
        },
        {
          label: '当前电量(%)',
          prop: 'quantityElectricity',
          type: 8,
          normal: true,
          minWidth: 120
        },
        // 智慧工牌
        {
          label: '剩余电量(%)',
          prop: 'battery',
          type: 10,
          normal: true,
          minWidth: 120
        },
        {
          label: '经度',
          prop: 'longitude',
          type: 10,
          normal: true,
          minWidth: 120
        },
        {
          label: '纬度',
          prop: 'latitude',
          type: 10,
          normal: true,
          minWidth: 120
        },
        {
          label: '收缩压(mmHg)',
          prop: 'lowpressure',
          type: 11,
          normal: true,
          minWidth: 120
        },
        {
          label: '舒张压(mmHg)',
          prop: 'highpressure',
          type: 11,
          normal: true,
          minWidth: 120
        },
        {
          label: '心率(次/min)',
          prop: 'rate',
          type: 11,
          normal: true,
          minWidth: 120
        },
        {
          label: '经度',
          prop: 'longitude',
          type: 11,
          normal: true,
          minWidth: 120
        },
        {
          label: '纬度',
          prop: 'latitude',
          type: 11,
          normal: true,
          minWidth: 120
        },
        {
          label: '流速（L/min）',
          prop: 'flow',
          type: 12,
          normal: true,
          minWidth: 120
        },
        {
          label: '水压（Mpa）',
          prop: 'pressure',
          type: 12,
          normal: true,
          minWidth: 120
        },
        {
          label: '水压状态',
          prop: 'pressureStatus',
          type: 12,
          normal: true,
          minWidth: 120
        },
        {
          label: '运行状态',
          prop: 'switchStatus',
          type: 13,
          normal: true,
          minWidth: 120
        }
      ],
      addressShow: false,
      map: null,
      marker: [],
      info: {
        longitude: '',
        latitude: '',
        deviceNumber: ''
      },
      directionTransition: directionTransition,
      runStateList: {
        0: '割草',
        1: '待机',
        2: '回仓',
        3: '休眠等待',
        4: '充电',
        5: '故障'
      },
      pressureStatusList: ['正常', '过低', '过高'],
      // 土壤温湿 虫情 水质监测 空气质量 水表 智慧断路器 智慧监控 垃圾桶
      dataUrlList: [
        this.$apis.iot.selectSoilInfoByPage,
        this.$apis.iot.selectInsectInfoByPage,
        this.$apis.iot.selectWaterQualityInfoByPage,
        this.$apis.iot.selectWeatherInfoByPage,
        this.$apis.iot.selectWaterInfoByPage,
        this.$apis.iot.selectJgCircuitBreakerInfoByPage,
        this.$apis.iot.selectCameraDemoInfoByPage,
        this.$apis.iot.selectTrashcanInfoByPage,
        this.$apis.iot.selectMowingInfoByPage,
        this.$apis.iot.selectJgIrrigationValveByPage,
        this.$apis.iot.selectYhWorkerDeviceByList,
        this.$apis.iot.selectYhWorkerDeviceByList,
        this.$apis.iot.selectWaterLyInfoByPage,
        this.$apis.iot.selectJgSprayInfoByPage
      ],
      allocateUrlList: [
        this.$apis.iot.updateSoilInfo,
        this.$apis.iot.updateInsectInfo,
        this.$apis.iot.updateWaterQualityInfo,
        this.$apis.iot.updateWeatherInfo,
        this.$apis.iot.updateWaterInfo,
        this.$apis.iot.updateJgCircuitBreakerInfo,
        this.$apis.iot.updateCameraDemoInfo,
        this.$apis.iot.updateTrashcanInfo,
        this.$apis.iot.updateMowingInfo,
        this.$apis.iot.updateJgIrrigationValveProject,
        this.$apis.iot.updateWorkerInfoProject,
        this.$apis.iot.updateWorkerInfoProject,
        this.$apis.iot.updateWaterLyInfo,
        this.$apis.iot.updateJgSprayInfo
      ]
    }
  },
  watch: {
  },
  computed: {
    selection () {
      return this.$refs.tables.selection
    },
    deviceNumber () {
      return this.$route.params.deviceNumber
    },
    menus () {
      return this.$store.state.menuList
    }
  },
  created () {
    this.getShowType()
    this.getProjectList()
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    initData () {
      if (this.deviceType !== -1) {
        this.getData()
      }
    },
    // 查询
    searchData () {
      this.page = 1
      this.getData()
    },
    getProjectList () {
      this.$axios.get(this.$apis.project.selectJgProjectAllByList).then(res => {
        this.projectList = res || []
      })
    },
    getShowType () {
      const data = JSON.stringify(this.menus.flat())
      this.typeList.forEach((item) => {
        if (data.indexOf(item.name1) !== -1) {
          item.showType = true
        }
      })
      this.deviceType = this.typeList.findIndex(item => item.showType)
      this.deviceType !== -1 && this.getData()
    },
    getData () {
      this.loading = true
      const data = ['soil', '', 'jgWaterQualityInfo', 'jgWeatherInfo', 'jgWaterInfo', 'jgCircuitBreakerInfo', '', 'jgTrashcanInfo', '', '', 'workerInfo', 'workerInfo', 'jgWaterLyInfo', 'jgSprayInfo']
      this.$axios.get(this.dataUrlList[Number(this.deviceType)], {
        ...this.searchInfo,
        page: this.page,
        size: this.size,
        deviceType: this.deviceType === 10 ? 'S0' : this.deviceType === 11 ? 'D0' : ''
      }).then(res => {
        if (data[Number(this.deviceType)]) {
          // 土壤 水质 环境
          this.total = res[data[Number(this.deviceType)]].total || 0
          this.tableData = res[data[Number(this.deviceType)]].list || []
        } else {
          // 虫情 电磁阀
          this.total = res.total || 0
          this.tableData = res.list || []
        }
        this.finds = res.finds || []
      }).finally(() => {
        this.loading = false
      })
    },
    changeType (index) {
      this.deviceType = index
      this.tableData = []
      setTimeout(() => {
        this.searchData()
      }, 0)
    },
    // 判断展示字段
    getTableTRList () {
      return this.tableTR.filter(item => {
        if (item.normal) {
          return true && item.type === this.deviceType
        } else {
          return this.finds.find((items) => items === item.prop) && item.type === this.deviceType
        }
      })
    },
    // 批量分配
    batchAllocate () {
      if (this.selection.length) {
        const isAllot = this.selection.find((item) => item.allotStatus === '1')
        if (isAllot) {
          this.$confirm('勾选项有设备已分配, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.showAllocateDialog = true
            this.allocateInfo.deviceNumber = this.selection.map(item => item.deviceNumber)
          }).catch(() => {
          })
        } else {
          this.showAllocateDialog = true
          this.allocateInfo.deviceNumber = this.selection.map(item => item.deviceNumber)
        }
      } else {
        this.$message.error('请选择要分配的设备')
      }
    },
    // 单个分配
    allocate (row) {
      if (row.allotStatus === '1') {
        this.$confirm('该设备已分配, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.showAllocateDialog = true
          this.allocateInfo.deviceNumber = [row.deviceNumber]
          this.allocateInfo.projectId = row.projectId || ''
        }).catch(() => {
        })
      } else {
        this.showAllocateDialog = true
        this.allocateInfo.deviceNumber = [row.deviceNumber]
      }
    },
    // 分配数据校验
    allocateDevice () {
      this.$refs.allocateForm.validate(valid => {
        if (valid) {
          this.doAllocateDevice()
        }
      })
    },
    // 分配执行
    doAllocateDevice () {
      this.allocateLoading = true
      this.$axios.post(this.allocateUrlList[Number(this.deviceType)], { ...this.allocateInfo,
        deviceType: this.deviceType === 10 ? 'S0' : this.deviceType === 11 ? 'D0' : ''}).then(() => {
        this.$message.success('分配成功')
        this.$refs.tables.clearSelection()
        this.getData()
      }).finally(() => {
        this.allocateLoading = false
        this.showAllocateDialog = false
        this.allocateInfo.projectId = ''
      })
    },
    // 批量配置
    batchDeploy () {
      if (this.selection.length) {
        if (this.deviceType === 0) {
          this.soilDialog = true
          this.allocateInfo.deviceNumber = this.selection.map(item => item.deviceNumber)
        }
      } else {
        this.$message.error('请选择要配置的设备')
      }
    },
    // 单个配置
    deploy (row) {
      if (this.deviceType === 12) {
        this.waterDialog = true
        this.allocateInfo = row
      } else {
        this.soilDialog = true
        this.allocateInfo.deviceNumber = [row.deviceNumber]
      }
    },
    // 配置弹窗关闭
    closeDialog () {
      this.soilDialog = false
    },
    toDetail (data) {
      this.$router.push('/iot/deviceDetail?deviceNumber=' + data.deviceNumber + '&deviceType=' + this.deviceType + '&projectId=' + data.projectId)
    },
    // 历史数据
    toHistory (deviceNumber) {
      const nameList = ['deviceSoilHistory', 'deviceInsectHistory', 'deviceWaterHistory', 'deviceWeatherHistory', 'waterInfoHistory', 'electronicHistory', '', 'trashHistory', 'MowingHistory', 'IrrigationHistory', 'deviceWordCardHistory', 'deviceBraceletHistory', 'deviceSpeedHistory', 'mistForestHistory']
      this.$router.push({ name: nameList[Number(this.deviceType)], params: { deviceNumber: deviceNumber } })
    }
  }
}
</script>

 <style scoped lang="scss">
 ::v-deep .el-card__body {
  display: flex;
  padding: 20px !important;
}
.left {
  width: 300px;
  height: 100%;
  margin-right: 20px;
  background: #F6F8FB;
  box-shadow: 0px 1px 2px 0px rgba(139,172,237,0.1);
  border-radius: 10px;
  padding: 25px 25px 25px 15px;
  .leftItem {
    height: 32px;
    border-radius: 20px;
    line-height: 32px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000517;
    padding-left: 20px;
    margin-bottom: 10px;
    cursor: pointer;
    &.current {
      background: var(--color-primary);
      box-shadow: 0px 2px 4px 0px #E5E4FF;
      color: #FFFFFF;
    }
  }
}
.right {
  width: calc(100% - 320px);
  height: 100%;
}
#map {
  width: 100%;
  height: 450px;
  border-radius:  0 0 10px 10px;
}

::v-deep .dialog-form1 {
  .el-dialog__header {
    border-bottom: none;
    padding: 22px 20px;
    display: flex;
    align-items: center;
    .el-dialog__title {
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
      text-shadow: 0px 6px 14px rgba(205,205,205,0.5);
    }
    .el-dialog__close {
      &::before {
        font-size: 16px;
      }
    }
  }
  .el-dialog__body {
    padding: 2px;
    position: relative;
    .el-input--small .el-input__inner {
      height: 36px;
      line-height: 36px;
    }
    .el-input__prefix {
      padding-top: 3px;
    }
  }
  .search {
    position: absolute;
    top: 20px;
    left: calc(50% - 250px);
  }

  .submitBtn {
    width: 80px;
    height: 32px;
    background: var(--color-primary);
    box-shadow: 0px 6px 14px 0px rgba(205,205,205,0.5);
    position: absolute;
    bottom: 18px;
    left: calc(50% - 40px);
    border-radius: 15px;
  }
}
 </style>
